// ─────────────────────────────────────────────────────────────────────────────
// Categories feature — API давхарга. Backend /merchant/category* endpoint-үүд.
// UI/логик энэ файлаас л сервертэй харьцана (шууд AxiosRequest дуудахгүй).
// ─────────────────────────────────────────────────────────────────────────────
import AxiosRequest from "shared/api/httpClient";

/** Мерчантын ангиллын мод (дээд + дэд). */
export async function getMerchantCategories() {
  return AxiosRequest({
    url: "/merchant/categories",
    method: "post",
  });
}

/** Шинэ ангилал үүсгэх. body: { name, rank, parentId }. */
export async function createMerchantCategory(body) {
  return AxiosRequest({
    url: "/merchant/category/create",
    method: "post",
    data: body,
  });
}

/** Ангиллын зураг upload (multipart). */
export async function uploadCategoryImage(file, id) {
  const formData = new FormData();
  formData.append("file", file);
  return AxiosRequest({
    url: `/upload/image/cat/${id}`,
    method: "post",
    isForm: true,
    data: formData,
  });
}

/** Ангилал засах. body: { name, rank }. */
export async function updateCategory(id, body) {
  return AxiosRequest({
    url: `/merchant/category/edit/${id}`,
    method: "post",
    data: body,
  });
}

/** Ангилал устгах. */
export async function deleteCategory(id) {
  return AxiosRequest({
    url: `/merchant/category/delete/${id}`,
    method: "post",
  });
}
